import { ENDPOINT_PERSONAL_ACCESS_TOKENS } from '../config'
import type { CreatePatRequest, CreatePatResponse } from '../types'
import AuthAxios from '@/lib/api/axios/AuthAxios'

const createPersonalAccessToken = async (
  params: CreatePatRequest,
): Promise<CreatePatResponse> => {
  const response = await AuthAxios.post<CreatePatResponse>(
    ENDPOINT_PERSONAL_ACCESS_TOKENS,
    params,
  )
  return response.data
}

export default createPersonalAccessToken
